import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id DA72E30D-C562-4E93-B8C8-CAFA686A1D23
 * name language-css3
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/language-css3.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const LanguageCss3Icon = createSvgIcon(<><path d="M5,3L4.35,6.34H17.94L17.5,8.5H3.92L3.26,11.83H16.85L16.09,15.64L10.61,17.45L5.86,15.64L6.19,14H2.85L2.06,18L9.91,21L18.96,18L20.16,11.97L20.4,10.76L21.94,3H5Z" /></>, 'LanguageCss3Icon');
export default LanguageCss3Icon